/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { guestResponseSchema } from "./guestResponseSchema.ts";
import { unauthorizedSchema } from "./unauthorizedSchema.ts";

export const userCurrentRetrieveStatus200Schema = guestResponseSchema.describe("Сериализатор вывода инфо о текущем пользователе.");

export const userCurrentRetrieveStatus401Schema = unauthorizedSchema.describe("Сериализатор 401 ошибки - для документации.");

export const userCurrentRetrieveResponseSchema = z.union([userCurrentRetrieveStatus200Schema, userCurrentRetrieveStatus401Schema]);
